import { IMAGES } from "./content";

export const LANGS = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  { code: "de", label: "Deutsch" },
  { code: "pl", label: "Polski" },
  { code: "pt", label: "Português" },
  { code: "fr", label: "Français" },
  { code: "nl", label: "Nederlands" },
  { code: "zh", label: "中文" },
];

// Language-neutral data (names, numbers, media, account)
export const NEUTRAL = {
  images: IMAGES,
  bank: {
    accountHolder: "Reina Yohana Isaza Montoya",
    bankName: "BBVA",
    iban: "ES02 0182 5645 1502 0164 8852",
    bic: "BBVAESMM",
    paypalLink: "",
  },
  video: { featured: "2NO3nz_djcU", shorts: ["BfYe8uzb0Z4", "GKKkhE5KfYI"] },
  giftVideo: "bw7Uy0oUN-c",
  gofundmeUrl: "https://gofund.me/d928f0d3f",
  contacts: [
    { name: "Maria-Katharina Richters", phone: "+49 175 8412853", wa: "491758412853", role: "fundraiser", roleEs: "organizadora" },
    { name: "David Parra Lezama", phone: "+34 644 09 23 22", wa: "34644092322", role: "in Spain", roleEs: "en España" },
    { name: "Dra. Milagros Lezama", phone: "+353 83 873 7026", wa: "353838737026", role: "David's mother", roleEs: "madre de David" },
    { name: "Reina Yohana Isaza Montoya", phone: "+34 643 07 00 98", wa: "34643070098", role: "receives donations", roleEs: "recibe las donaciones" },
  ],
};

const GALLERY_IMG = [
  IMAGES.groceryCart,
  IMAGES.suppliesTable,
  IMAGES.waterTanks,
  IMAGES.bagsOnTable,
  IMAGES.mealsCar,
  IMAGES.mealsPacking,
];

const BAGS_QUOTE =
  "Buenas tardes. Preparamos unas bolsas para un sector donde hay 150 damnificados en Las Minas de Baruta.";

export const STRINGS = {
  en: {
    nav: { story: "The Story", gallery: "Gallery", donate: "Donate" },
    hero: {
      overline: "Emergency Earthquake Relief · Venezuela",
      lines: ["Emergency", "Earthquake Relief", "Venezuela."],
      body:
        "On 24 June 2026, two devastating earthquakes of magnitude 7.2 and 7.5 struck Venezuela, severely affecting La Guaira, Caracas, and surrounding communities. Thousands have lost their lives, and many more are injured, displaced, or left without homes, food, clean water, and medical supplies.",
      donateNow: "Donate on GoFundMe",
      readStory: "Read the full story",
      caption: "A message from Pastor Ángel Aner González",
      captionLoc: "Venezuela",
    },
    panel: {
      support: "Support the relief effort",
      choose: "Choose an amount to contribute.",
      customBtn: "Contribute another amount",
      raisedLine: (goal) => `raised of ${goal} goal`,
      donationsLabel: (n) => `${n} donations`,
      info:
        "Contributions go directly to food, clean water, medical necessities, and emergency supplies for the community in Venezuela. Donate securely through our GoFundMe page.",
      note:
        "All donations are made through our GoFundMe campaign. Funds are then transferred to Reina Yohana Isaza Montoya in Spain, who sends them to Pastor Ángel Aner González for Iglesia Cristiana Ríos de Agua Viva in Venezuela.",
      manualUpdate:
        "Progress above is fetched live from GoFundMe and refreshes about every five minutes.",
    },
    manifesto: {
      overline: "What we are doing",
      heading: "A community-led humanitarian response.",
      chapters: [
        {
          n: "01",
          title: "What happened",
          body:
            "Two consecutive earthquakes, magnitude 7.2 and 7.5, struck Venezuela on 24 June 2026, severely affecting La Guaira, Caracas and surrounding communities. Thousands have lost their lives. Many more are injured, displaced, or left without homes, food, clean water, medical supplies and other basic necessities. Communities are still searching for loved ones, supporting survivors, and beginning to rebuild.",
          tag: "24 June 2026 · M7.2 & M7.5",
        },
        {
          n: "02",
          title: "Our work on the ground",
          body:
            "Iglesia Cristiana Ríos de Agua Viva, led by Pastor Ángel Aner González, has organised a local humanitarian response. The pastor, church members and local volunteers are working directly in and around the affected communities, preparing and distributing food and drinks to rescue workers, survivors and displaced families. The church wants to continue and expand this work, but more financial support is urgently needed.",
          tag: "Iglesia Cristiana Ríos de Agua Viva",
        },
        {
          n: "03",
          title: "Our international support network",
          body:
            "Dra. Milagros Lezama is in direct contact with Pastor Ángel, helping to coordinate support for the church's humanitarian work. Her son, David Parra Lezama, and his wife, Reina Yohana Isaza Montoya, are based in Spain and are gathering international support. Members of their family in Venezuela are also assisting the church locally. Through this close network, photos, videos and updates come directly from those involved in the response.",
          tag: "Family in Spain and Venezuela",
        },
      ],
    },
    scale: {
      overline: "The scale, as reported",
      items: [
        { value: "4,734", label: "lives lost" },
        { value: "16,740", label: "people injured" },
        { value: "17,907", label: "homes lost" },
      ],
      footnote:
        "Figures from Situation Report No. 21 (14 July 2026): 6,462 people rescued and more than 1,275 aftershocks recorded. Numbers are official and may change as recovery continues.",
    },
    where: {
      overline: "How your contribution will help",
      heading: "Every donation becomes something people can hold.",
      intro:
        "Every donation, no matter the size, goes directly to Iglesia Cristiana Ríos de Agua Viva for its ongoing relief work.",
      allocations: [
        { title: "Food & prepared meals", note: "Cooked and distributed daily to rescue workers, survivors and displaced families." },
        { title: "Clean drinking water", note: "Bottled and safe water carried to the field where it is needed most." },
        { title: "Medical necessities", note: "Essential medications, first aid and supplies for the injured and vulnerable." },
        { title: "Hygiene products", note: "Soap, sanitary items and cleaning supplies for shelters and families." },
        { title: "Emergency supplies", note: "Blankets, containers, gas and equipment to keep the field kitchen and relief effort running." },
        { title: "Support for displaced families", note: "Direct, practical help for families who lost their homes and remain in vulnerable situations." },
      ],
    },
    trust: {
      overline: "Trust & transparency",
      heading: "How your donation reaches the people",
      flow:
        "Donations are passed to David and Reina, my direct contacts here in Spain, who send them to their family in Venezuela. Working with the church Iglesia Cristiana Ríos de Agua Viva (Pastor Ángel Aner González), their family buys and delivers the aid in their hometown. Everyone who contributes can receive a justificante (proof of transfer).",
      points: [
        { title: "100% goes to aid", note: "Every donation is spent on food, clean water and supplies. Nothing is taken out." },
        { title: "Proof of transfer", note: "Ask for a justificante and we will share the transfer confirmation for your donation." },
        { title: "Receipts & photos", note: "We keep receipts and photos of what we buy, available to any donor on request." },
        { title: "Video updates", note: "We are adding short videos from the people involved, so you can see where your help goes." },
      ],
      contactLead: "Questions? Reach a real person:",
    },
    note: {
      overline: "About this page · For transparency",
      heading: "Who built this page",
      role: "Independent supporter · Jávea, Spain",
      paragraphs: [
        "This page was built by Maria-Katharina Richters, an independent supporter based in Spain. She is a personal friend of David Parra Lezama and Reina Yohana Isaza Montoya, which is how she learned about this humanitarian effort, and created this page to help share the campaign. She does not handle any donations; all contributions go directly through GoFundMe.",
      ],
      signoff: "",
      contactLead: "",
    },
    transparency: {
      overline: "Donation transparency",
      heading: "How donations reach the church.",
      body:
        "All donations are made securely through our GoFundMe campaign. Funds are then transferred to the Spanish bank account of Reina Yohana Isaza Montoya, and from there directly to the account of Pastor Ángel Aner González for Iglesia Cristiana Ríos de Agua Viva, so the church can use them for food, clean water, medical necessities, hygiene products, emergency supplies, and direct support to people affected by the earthquakes.",
      builderNote:
        "This page was built by Maria-Katharina Richters, an independent supporter based in Jávea, Spain, to help share the campaign. She does not handle any donations.",
    },
    videos: {
      overline: "From Venezuela",
      heading: "See it for yourself",
      intro:
        "Short videos David and Reina have shared of the family and their church at work, buying and handing out food, water and supplies.",
    },
    gallery: {
      overline: "From the site",
      heading: "Photographs from the field.",
      intro: "Unedited photographs from our volunteers as they prepare and hand out food and water.",
      captions: [
        BAGS_QUOTE,
        "Supplies gathered for the community",
        "Loading water and supplies",
        "Food and essentials for the families",
        "Meals and water, ready for delivery",
        "Preparing meals, one by one",
      ],
    },
    donors: {
      grateful: "With gratitude",
      getInvolved: "Get involved",
      thanksHeading: "Thank you to those who have given.",
      firstHeading: "Be the first to help.",
      thanksBody:
        "Every contribution goes toward meals and clean water for the rescue teams and survivors. We are grateful to everyone who has helped.",
      firstBody:
        "No donations yet. This effort is just getting started, and your contribution would be the first. Every gift goes toward meals and clean water on the ground.",
      contribute: "Contribute",
      emptyTitle: "No supporters yet",
      emptyBody: "As soon as the first donation comes in, it will appear here, with a message of support if one is left.",
      anon: "Contributed anonymously.",
    },
    footer: {
      support: "Support",
      heading: "Thank you for your solidarity.",
      contribute: "Contribute",
      organizedBy: "Organized by",
      org2: "Pastor Ángel Aner González · a personal fundraiser by Maria.",
      bottomOrg: "A personal fundraiser by Maria-Katharina Richters · Venezuela",
      shareText:
        "Support earthquake relief in Venezuela. Meals and clean water for rescue teams and survivors after the 24 June 2026 earthquakes.",
      copyToast: "Link copied. Thank you for sharing.",
    },
    bank: {
      badge: "Donate on GoFundMe",
      anyAmount: "Every donation matters",
      transfer: (a) => `Donate $${a}`,
      intro:
        "Contributions are made securely through our GoFundMe page. Click below to donate, every amount, small or large, helps the church's ongoing relief work in Venezuela.",
      labels: { holder: "Account holder", bank: "Bank", iban: "IBAN", bic: "BIC / SWIFT", reference: "Reference" },
      referenceValue: "Venezuela Relief + your name",
      note: "Funds raised through GoFundMe are transferred to the Spanish bank account of Reina Yohana Isaza Montoya, then directly to Pastor Ángel Aner González for Iglesia Cristiana Ríos de Agua Viva.",
      paypal: "Or donate with PayPal",
      copyToast: (label) => `${label} copied`,
      contactHelp: "Prefer to give another way? Contact us and we will help.",
    },
    gift: {
      overline: "A small thank-you",
      heading: "Send your address for a thank-you gift",
      intro:
        "As a thank-you for your donation, we would love to send you a customised gift: a mug, a tote bag, or a t-shirt. Tell us where to send it and your nationality (the design is customised to it). See the example below.",
      giftLabel: "Choose a gift",
      gifts: { mug: "Mug", bag: "Tote bag", tshirt: "T-shirt" },
      fields: {
        name: "Full name",
        email: "Email",
        address: "Postal address",
        country: "Nationality / country",
        size: "T-shirt size",
        message: "Message (optional)",
      },
      sizeHint: "Only needed for t-shirts",
      submit: "Send my details",
      success: "Thank you! We have your details and will be in touch.",
      error: "Something went wrong. Please try again.",
      videoNote: "Example video coming soon.",
      privacy: "Your address is used only to send your thank-you gift.",
    },
    giftFlow: {
      teaserOverline: "A small thank-you",
      teaserHeading: "Every donor receives a handmade thank-you gift",
      teaserBody: "A mug, a tote bag or a t-shirt, customised to your country. It's our way of saying thank you. Make your donation, then claim your gift in the final step.",
      teaserCta: "Donate & claim your gift",
      step1Note: "Your thank-you gift is sent after we confirm your donation. Donate on GoFundMe above, then come back to claim your gift.",
      claimCta: "I've donated, claim my gift",
      skip: "I'll pass on the gift",
      heading: "Claim your thank-you gift",
      intro: "Enter your GoFundMe donor name or the reference you used so we can match your donation. Your gift is sent once we confirm your contribution.",
      back: "Back to donation",
      refLabel: "Your GoFundMe donor name (or transfer reference)",
      amountLabel: "Amount you donated (optional)",
      sizeLabel: "Choose your size",
    },
    marquee: ["La Guaira", "Caracas", "Humanitarian relief", "Volunteer aid"],
    galleryImg: GALLERY_IMG,
  },

  es: {
    nav: { story: "La Historia", gallery: "Galería", donate: "Donar" },
    hero: {
      overline: "Ayuda de emergencia por el terremoto · Venezuela",
      lines: ["Ayuda de emergencia", "por el terremoto", "Venezuela."],
      body:
        "El 24 de junio de 2026, dos devastadores terremotos de magnitud 7,2 y 7,5 sacudieron Venezuela, afectando gravemente a La Guaira, Caracas y las comunidades cercanas. Miles de personas han perdido la vida, y muchas más están heridas, desplazadas o sin hogar, sin alimentos, agua potable ni suministros médicos.",
      donateNow: "Donar en GoFundMe",
      readStory: "Leer la historia completa",
      caption: "Un mensaje del Pastor Ángel Aner González",
      captionLoc: "Venezuela",
    },
    panel: {
      support: "Apoya la ayuda",
      choose: "Elige una cantidad para contribuir.",
      customBtn: "Contribuir otra cantidad",
      raisedLine: (goal) => `recaudados de una meta de ${goal}`,
      donationsLabel: (n) => `${n} donaciones`,
      info:
        "Las contribuciones van directamente a comida, agua potable y suministros para la comunidad en Venezuela. Las donaciones se realizan por transferencia bancaria directa. Los datos aparecen en el siguiente paso.",
      note:
        "Las donaciones se realizan por transferencia bancaria a David y Reina en España, que las envían a su familia en Venezuela. Se puede solicitar un justificante de la transferencia.",
      manualUpdate:
        "Como las donaciones se hacen por transferencia bancaria manual, la cantidad recaudada se actualiza aquí a mano; vuelve cada pocos días para ver el total más reciente.",
    },
    scale: {
      overline: "La magnitud, según los informes",
      items: [
        { value: "4.734", label: "vidas perdidas" },
        { value: "16.740", label: "personas heridas" },
        { value: "17.907", label: "hogares perdidos" },
      ],
      footnote:
        "Cifras del Informe de Situación n.º 21 (14 de julio de 2026): 6.462 personas rescatadas y más de 1.275 réplicas registradas. Son cifras oficiales y pueden cambiar a medida que avanza la recuperación.",
    },
    trust: {
      overline: "Confianza y transparencia",
      heading: "Cómo llega tu donación a la gente",
      flow:
        "Las donaciones se entregan a David y Reina, mis contactos directos aquí en España, que las envían a su familia en Venezuela. Junto con la iglesia Iglesia Cristiana Ríos de Agua Viva (Pastor Ángel Aner González), su familia compra y reparte la ayuda en su pueblo. Todo el que contribuye puede recibir un justificante de la transferencia.",
      points: [
        { title: "100% para la ayuda", note: "Cada donación se gasta en comida, agua y suministros. No se retiene nada." },
        { title: "Justificante", note: "Pide un justificante y te enviaremos el comprobante de la transferencia de tu donación." },
        { title: "Recibos y fotos", note: "Guardamos recibos y fotos de lo que compramos, disponibles para cualquier donante que lo solicite." },
        { title: "Vídeos", note: "Estamos añadiendo vídeos cortos de las personas implicadas, para que veas a dónde va tu ayuda." },
      ],
      contactLead: "¿Preguntas? Habla con una persona real:",
    },
    videos: {
      overline: "Desde Venezuela",
      heading: "Míralo tú mismo",
      intro:
        "Vídeos cortos que David y Reina han compartido de la familia y su iglesia trabajando: comprando y repartiendo comida, agua y suministros.",
    },
    gallery: {
      overline: "Sobre el terreno",
      heading: "Fotografías del terreno.",
      intro: "Fotografías sin editar de nuestros voluntarios preparando y repartiendo comida y agua.",
      captions: [
        BAGS_QUOTE,
        "Suministros reunidos para la comunidad",
        "Cargando agua y suministros",
        "Comida y productos básicos para las familias",
        "Comidas y agua, listas para repartir",
        "Preparando comidas, una a una",
      ],
    },
    donors: {
      grateful: "Con gratitud",
      getInvolved: "Participa",
      thanksHeading: "Gracias a quienes han donado.",
      firstHeading: "Sé el primero en ayudar.",
      thanksBody:
        "Cada contribución se destina a comida y agua para los equipos de rescate y los supervivientes. Agradecemos a todos los que han ayudado.",
      firstBody:
        "Aún no hay donaciones. Esta iniciativa acaba de empezar y tu contribución sería la primera. Cada aportación se destina a comida y agua sobre el terreno.",
      contribute: "Contribuir",
      emptyTitle: "Aún no hay donantes",
      emptyBody: "En cuanto llegue la primera donación, aparecerá aquí, con un mensaje de apoyo si se deja alguno.",
      anon: "Contribución anónima.",
    },
    footer: {
      support: "Apoya",
      heading: "Gracias por tu solidaridad.",
      contribute: "Contribuir",
      organizedBy: "Organizado por",
      org2: "Pastor Ángel Aner González · una recaudación personal de Maria.",
      bottomOrg: "Una recaudación personal de Maria-Katharina Richters · Venezuela",
      shareText:
        "Apoya la ayuda por los terremotos en Venezuela. Comida y agua para los equipos de rescate y los supervivientes tras los terremotos del 24 de junio de 2026.",
      copyToast: "Enlace copiado. Gracias por compartir.",
    },
    bank: {
      badge: "Dona por transferencia bancaria",
      anyAmount: "Cualquier cantidad es bienvenida",
      transfer: (a) => `Transferir $${a}`,
      intro:
        'Las donaciones se hacen por transferencia bancaria directa. Usa los datos de abajo y pon "Venezuela Relief" y tu nombre como concepto para que podamos agradecértelo y enviarte un justificante.',
      labels: { holder: "Titular de la cuenta", bank: "Banco", iban: "IBAN", bic: "BIC / SWIFT", reference: "Concepto" },
      referenceValue: "Venezuela Relief + tu nombre",
      note: "Esta cuenta pertenece a Reina Yohana Isaza Montoya (esposa de David), que envía los fondos a su familia en Venezuela.",
      paypal: "O dona con PayPal",
      copyToast: (label) => `${label} copiado`,
      contactHelp: "¿Prefieres donar de otra forma? Contáctanos y te ayudamos.",
    },
    gift: {
      overline: "Un pequeño agradecimiento",
      heading: "Envía tu dirección para un regalo de agradecimiento",
      intro:
        "Como agradecimiento por tu donación, nos encantaría enviarte un regalo personalizado: una taza, una bolsa de tela o una camiseta. Dinos a dónde enviarlo y tu nacionalidad (el diseño se personaliza según ella). Mira el ejemplo a continuación.",
      giftLabel: "Elige un regalo",
      gifts: { mug: "Taza", bag: "Bolsa de tela", tshirt: "Camiseta" },
      fields: {
        name: "Nombre completo",
        email: "Correo electrónico",
        address: "Dirección postal",
        country: "Nacionalidad / país",
        size: "Talla de camiseta",
        message: "Mensaje (opcional)",
      },
      sizeHint: "Solo para camisetas",
      submit: "Enviar mis datos",
      success: "¡Gracias! Tenemos tus datos y nos pondremos en contacto.",
      error: "Algo salió mal. Inténtalo de nuevo.",
      videoNote: "Vídeo de ejemplo próximamente.",
      privacy: "Tu dirección solo se usa para enviarte tu regalo de agradecimiento.",
    },
    giftFlow: {
      teaserOverline: "Un pequeño agradecimiento",
      teaserHeading: "Cada donante recibe un regalo de agradecimiento hecho a mano",
      teaserBody: "Una taza, una bolsa de tela o una camiseta, personalizada según tu país. Es nuestra forma de decir gracias. Haz tu donación y reclama tu regalo en el último paso.",
      teaserCta: "Dona y reclama tu regalo",
      step1Note: "Tu regalo se envía después de donar. Haz tu transferencia abajo y recláma­lo en el siguiente paso.",
      claimCta: "Ya hice mi transferencia, reclamar mi regalo",
      skip: "Prefiero no recibir el regalo",
      heading: "Reclama tu regalo de agradecimiento",
      intro: "Introduce el concepto que usaste para que podamos identificar tu donación. Tu regalo se envía una vez confirmada tu transferencia.",
      back: "Volver a los datos de la transferencia",
      refLabel: "Concepto que usaste en la transferencia",
      amountLabel: "Cantidad que donaste (opcional)",
      sizeLabel: "Elige tu talla",
    },
    marquee: ["La Guaira", "Caracas", "Ayuda humanitaria", "Ayuda voluntaria"],
    galleryImg: GALLERY_IMG,
  },

  de: {
    nav: { story: "Die Geschichte", gallery: "Galerie", donate: "Spenden" },
    hero: {
      overline: "Erdbeben-Nothilfe · Venezuela",
      lines: ["Erdbeben", "Nothilfe", "Venezuela."],
      body:
        "Am 24. Juni 2026 erschütterten zwei verheerende Erdbeben der Stärke 7,2 und 7,5 Venezuela und trafen La Guaira, Caracas und umliegende Gemeinden schwer. Tausende Menschen haben ihr Leben verloren, viele weitere sind verletzt, vertrieben oder ohne Zuhause, ohne Lebensmittel, sauberes Wasser und medizinische Versorgung.",
      donateNow: "Auf GoFundMe spenden",
      readStory: "Die ganze Geschichte lesen",
      caption: "Eine Botschaft von Pastor Ángel Aner González",
      captionLoc: "Venezuela",
    },
    panel: {
      support: "Unterstütze die Hilfe",
      choose: "Wähle einen Betrag zum Spenden.",
      customBtn: "Anderen Betrag spenden",
      raisedLine: (goal) => `gesammelt von ${goal} Ziel`,
      donationsLabel: (n) => `${n} Spenden`,
      info:
        "Die Beiträge fließen direkt in Essen, sauberes Wasser und Hilfsgüter für die Gemeinschaft in Venezuela. Spenden erfolgen per Banküberweisung. Die Details erscheinen im nächsten Schritt.",
      note:
        "Spenden erfolgen per Banküberweisung an David und Reina in Spanien, die sie an ihre Familie in Venezuela weiterleiten. Ein Nachweis (justificante) ist auf Anfrage erhältlich.",
      manualUpdate:
        "Da Spenden per manueller Banküberweisung erfolgen, wird der gesammelte Betrag hier von Hand aktualisiert – schau alle paar Tage vorbei, um den neuesten Stand zu sehen.",
    },
    scale: {
      overline: "Das Ausmaß, laut Berichten",
      items: [
        { value: "4.734", label: "Todesopfer" },
        { value: "16.740", label: "Verletzte" },
        { value: "17.907", label: "zerstörte Häuser" },
      ],
      footnote: "Zahlen aus Lagebericht Nr. 21 (14. Juli 2026): 6.462 gerettete Personen und über 1.275 registrierte Nachbeben. Die Zahlen sind offiziell und können sich ändern.",
    },
    trust: {
      overline: "Vertrauen & Transparenz",
      heading: "Wie deine Spende die Menschen erreicht",
      flow: "Spenden gehen an David und Reina, meine direkten Kontakte hier in Spanien, die sie an ihre Familie in Venezuela senden. Gemeinsam mit der Kirche Iglesia Cristiana Ríos de Agua Viva (Pastor Ángel Aner González) kauft und verteilt ihre Familie die Hilfe in ihrer Heimatstadt. Jeder, der spendet, kann einen Nachweis (justificante) erhalten.",
      points: [
        { title: "100% für die Hilfe", note: "Jede Spende fließt in Essen, Wasser und Hilfsgüter. Es wird nichts einbehalten." },
        { title: "Überweisungsnachweis", note: "Bitte um einen justificante und wir senden dir die Überweisungsbestätigung." },
        { title: "Belege & Fotos", note: "Wir bewahren Belege und Fotos unserer Einkäufe auf, auf Anfrage verfügbar." },
        { title: "Video-Updates", note: "Wir fügen kurze Videos der beteiligten Menschen hinzu, damit du siehst, wohin deine Hilfe geht." },
      ],
      contactLead: "Fragen? Erreiche eine echte Person:",
    },
    videos: { overline: "Aus Venezuela", heading: "Sieh es selbst", intro: "Kurze Videos, die David und Reina von der Familie und ihrer Kirche bei der Arbeit geteilt haben: Einkaufen und Verteilen von Essen, Wasser und Hilfsgütern." },
    gallery: {
      overline: "Vor Ort",
      heading: "Fotos aus dem Einsatz.",
      intro: "Unbearbeitete Fotos unserer Freiwilligen beim Zubereiten und Verteilen von Essen und Wasser.",
      captions: [BAGS_QUOTE, "Gesammelte Hilfsgüter für die Gemeinschaft", "Wasser und Vorräte werden geladen", "Essen und Grundbedarf für die Familien", "Mahlzeiten und Wasser, bereit zur Verteilung", "Mahlzeiten vorbereiten, eine nach der anderen"],
    },
    donors: {
      grateful: "Mit Dankbarkeit", getInvolved: "Mach mit",
      thanksHeading: "Danke an alle, die gespendet haben.", firstHeading: "Sei der Erste, der hilft.",
      thanksBody: "Jeder Beitrag fließt in Essen und sauberes Wasser für die Rettungsteams und Überlebenden. Wir danken allen, die geholfen haben.",
      firstBody: "Noch keine Spenden. Diese Aktion beginnt gerade, und dein Beitrag wäre der erste. Jede Gabe fließt in Essen und sauberes Wasser vor Ort.",
      contribute: "Spenden", emptyTitle: "Noch keine Unterstützer",
      emptyBody: "Sobald die erste Spende eingeht, erscheint sie hier, mit einer Nachricht, falls eine hinterlassen wird.",
      anon: "Anonym gespendet.",
    },
    footer: {
      support: "Unterstützen", heading: "Danke für deine Solidarität.", contribute: "Spenden",
      organizedBy: "Organisiert von", org2: "Pastor Ángel Aner González · eine persönliche Spendenaktion von Maria.",
      bottomOrg: "Eine persönliche Spendenaktion von Maria-Katharina Richters · Venezuela",
      shareText: "Unterstütze die Erdbebenhilfe in Venezuela. Essen und sauberes Wasser nach den Erdbeben vom 24. Juni 2026.",
      copyToast: "Link kopiert. Danke fürs Teilen.",
    },
    bank: {
      badge: "Per Banküberweisung spenden", anyAmount: "Jeder Betrag ist willkommen",
      transfer: (a) => `$${a} überweisen`,
      intro: 'Spenden erfolgen per Banküberweisung. Bitte nutze die Angaben unten und gib "Venezuela Relief" und deinen Namen als Verwendungszweck an, damit wir uns bedanken und einen Nachweis senden können.',
      labels: { holder: "Kontoinhaber", bank: "Bank", iban: "IBAN", bic: "BIC / SWIFT", reference: "Verwendungszweck" },
      referenceValue: "Venezuela Relief + dein Name",
      note: "Dieses Konto gehört Reina Yohana Isaza Montoya (Davids Frau), die die Mittel an ihre Familie in Venezuela weiterleitet.",
      paypal: "Oder mit PayPal spenden", copyToast: (label) => `${label} kopiert`,
      contactHelp: "Möchtest du anders spenden? Kontaktiere uns, wir helfen gern.",
    },
    gift: {
      overline: "Ein kleines Dankeschön", heading: "Sende deine Adresse für ein Dankesgeschenk",
      intro: "Als Dank für deine Spende senden wir dir gerne ein personalisiertes Geschenk: eine Tasse, eine Stofftasche oder ein T-Shirt. Sag uns, wohin wir es senden sollen, und deine Nationalität (das Design wird darauf abgestimmt). Sieh dir das Beispiel unten an.",
      giftLabel: "Wähle ein Geschenk", gifts: { mug: "Tasse", bag: "Stofftasche", tshirt: "T-Shirt" },
      fields: { name: "Vollständiger Name", email: "E-Mail", address: "Postanschrift", country: "Nationalität / Land", size: "T-Shirt-Größe", message: "Nachricht (optional)" },
      sizeHint: "Nur für T-Shirts nötig", submit: "Meine Daten senden", success: "Danke! Wir haben deine Daten und melden uns.", error: "Etwas ist schiefgelaufen. Bitte versuche es erneut.", videoNote: "Beispielvideo folgt in Kürze.", privacy: "Deine Adresse wird nur zum Versand deines Dankesgeschenks verwendet.",
    },
    giftFlow: {
      teaserOverline: "Ein kleines Dankeschön",
      teaserHeading: "Jeder Spender erhält ein handgemachtes Dankeschön",
      teaserBody: "Eine Tasse, eine Stofftasche oder ein T-Shirt, auf dein Land abgestimmt. Es ist unser Dankeschön. Spende und fordere dein Geschenk im letzten Schritt an.",
      teaserCta: "Spenden & Geschenk anfordern",
      step1Note: "Dein Geschenk wird nach deiner Spende versendet. Überweise unten und fordere es im nächsten Schritt an.",
      claimCta: "Ich habe überwiesen, Geschenk anfordern",
      skip: "Ich verzichte auf das Geschenk",
      heading: "Fordere dein Dankeschön an",
      intro: "Gib den Verwendungszweck an, den du genutzt hast, damit wir deine Spende zuordnen können. Dein Geschenk wird versendet, sobald wir deine Überweisung bestätigt haben.",
      back: "Zurück zu den Überweisungsdaten",
      refLabel: "Verwendungszweck deiner Überweisung",
      amountLabel: "Gespendeter Betrag (optional)",
      sizeLabel: "Wähle deine Größe",
    },
    marquee: ["La Guaira", "Caracas", "Humanitäre Hilfe", "Freiwilligenhilfe"],
    galleryImg: GALLERY_IMG,
  },

  pl: {
    nav: { story: "Historia", gallery: "Galeria", donate: "Wesprzyj" },
    hero: {
      overline: "Pomoc doraźna po trzęsieniu ziemi · Wenezuela",
      lines: ["Pomoc doraźna", "po trzęsieniu ziemi", "Wenezuela."],
      body: "24 czerwca 2026 roku dwa niszczycielskie trzęsienia ziemi o sile 7,2 i 7,5 nawiedziły Wenezuelę, poważnie uderzając w La Guaira, Caracas i okoliczne społeczności. Tysiące osób straciło życie, a wiele więcej jest rannych, przesiedlonych lub pozbawionych domów, żywności, czystej wody i leków.",
      donateNow: "Wesprzyj na GoFundMe", readStory: "Przeczytaj pełną historię",
      caption: "Wiadomość od pastora Ángela Anera Gonzáleza", captionLoc: "Wenezuela",
    },
    panel: {
      support: "Wesprzyj pomoc", choose: "Wybierz kwotę wsparcia.", customBtn: "Wpłać inną kwotę",
      raisedLine: (goal) => `zebrano z celu ${goal}`, donationsLabel: (n) => `${n} wpłat`,
      info: "Wpłaty trafiają bezpośrednio na jedzenie, czystą wodę i zaopatrzenie dla społeczności w Wenezueli. Darowizny są dokonywane przelewem bankowym. Szczegóły w następnym kroku.",
      note: "Darowizny są przekazywane przelewem do Davida i Reiny w Hiszpanii, którzy wysyłają je swojej rodzinie w Wenezueli. Potwierdzenie przelewu (justificante) dostępne na życzenie.",
      manualUpdate: "Ponieważ darowizny są dokonywane ręcznym przelewem bankowym, zebrana kwota jest tu aktualizowana ręcznie – zaglądaj co kilka dni po najnowszą sumę.",
    },
    scale: {
      overline: "Skala, według raportów",
      items: [{ value: "4734", label: "ofiar śmiertelnych" }, { value: "16 740", label: "rannych" }, { value: "17 907", label: "utraconych domów" }],
      footnote: "Dane z Raportu Sytuacyjnego nr 21 (14 lipca 2026): 6462 uratowanych osób i ponad 1275 wstrząsów wtórnych. Liczby są oficjalne i mogą się zmieniać.",
    },
    trust: {
      overline: "Zaufanie i przejrzystość", heading: "Jak Twoja darowizna dociera do ludzi",
      flow: "Darowizny trafiają do Davida i Reiny, moich bezpośrednich kontaktów w Hiszpanii, którzy wysyłają je rodzinie w Wenezueli. Wraz z kościołem Iglesia Cristiana Ríos de Agua Viva (Pastor Ángel Aner González) ich rodzina kupuje i rozdaje pomoc. Każdy, kto wpłaca, może otrzymać potwierdzenie (justificante).",
      points: [
        { title: "100% na pomoc", note: "Każda darowizna idzie na jedzenie, wodę i zaopatrzenie. Nic nie jest potrącane." },
        { title: "Potwierdzenie przelewu", note: "Poproś o justificante, a wyślemy Ci potwierdzenie przelewu." },
        { title: "Rachunki i zdjęcia", note: "Przechowujemy rachunki i zdjęcia zakupów, dostępne na życzenie." },
        { title: "Aktualizacje wideo", note: "Dodajemy krótkie filmy od zaangażowanych osób, abyś widział, dokąd trafia pomoc." },
      ],
      contactLead: "Pytania? Skontaktuj się z prawdziwą osobą:",
    },
    videos: { overline: "Z Wenezueli", heading: "Zobacz sam", intro: "Krótkie filmy udostępnione przez Davida i Reinę, pokazujące rodzinę i ich kościół podczas pracy: zakupy oraz rozdawanie jedzenia, wody i zaopatrzenia." },
    gallery: {
      overline: "Z terenu", heading: "Zdjęcia z akcji.", intro: "Nieedytowane zdjęcia naszych wolontariuszy przygotowujących i rozdających jedzenie i wodę.",
      captions: [BAGS_QUOTE, "Zaopatrzenie zebrane dla społeczności", "Ładowanie wody i zaopatrzenia", "Jedzenie i artykuły pierwszej potrzeby dla rodzin", "Posiłki i woda gotowe do rozdania", "Przygotowywanie posiłków, jeden po drugim"],
    },
    donors: {
      grateful: "Z wdzięcznością", getInvolved: "Dołącz", thanksHeading: "Dziękujemy tym, którzy wpłacili.", firstHeading: "Bądź pierwszy.",
      thanksBody: "Każda wpłata idzie na jedzenie i czystą wodę dla ratowników i ocalałych. Dziękujemy wszystkim, którzy pomogli.",
      firstBody: "Nie ma jeszcze wpłat. Ta akcja dopiero się zaczyna, a Twoja wpłata byłaby pierwszą. Każdy dar idzie na jedzenie i wodę.",
      contribute: "Wesprzyj", emptyTitle: "Brak wspierających", emptyBody: "Gdy tylko pojawi się pierwsza wpłata, pokaże się tutaj, wraz z wiadomością, jeśli zostanie zostawiona.", anon: "Wpłata anonimowa.",
    },
    footer: {
      support: "Wsparcie", heading: "Dziękujemy za solidarność.", contribute: "Wespryj", organizedBy: "Organizuje",
      org2: "Pastor Ángel Aner González · osobista zbiórka Marii.", bottomOrg: "Osobista zbiórka Marii-Kathariny Richters · Wenezuela",
      shareText: "Wesprzyj pomoc po trzęsieniach ziemi w Wenezueli. Jedzenie i woda po trzęsieniach z 24 czerwca 2026.", copyToast: "Skopiowano link. Dziękujemy za udostępnienie.",
    },
    bank: {
      badge: "Wpłać przelewem bankowym", anyAmount: "Każda kwota jest mile widziana", transfer: (a) => `Przelej $${a}`,
      intro: 'Darowizny są dokonywane przelewem bankowym. Użyj poniższych danych i wpisz "Venezuela Relief" oraz swoje imię w tytule, abyśmy mogli podziękować i wysłać potwierdzenie.',
      labels: { holder: "Właściciel konta", bank: "Bank", iban: "IBAN", bic: "BIC / SWIFT", reference: "Tytuł przelewu" },
      referenceValue: "Venezuela Relief + Twoje imię", note: "To konto należy do Reiny Yohany Isazy Montoyi (żony Davida), która przekazuje środki rodzinie w Wenezueli.",
      paypal: "Lub wpłać przez PayPal", copyToast: (label) => `Skopiowano: ${label}`, contactHelp: "Wolisz wpłacić inaczej? Skontaktuj się z nami.",
    },
    gift: {
      overline: "Małe podziękowanie", heading: "Wyślij swój adres, aby otrzymać podziękowanie",
      intro: "W podziękowaniu za darowiznę chętnie wyślemy Ci spersonalizowany prezent: kubek, torbę lub koszulkę. Podaj, gdzie go wysłać, oraz swoją narodowość (projekt jest do niej dopasowany). Zobacz przykład poniżej.",
      giftLabel: "Wybierz prezent", gifts: { mug: "Kubek", bag: "Torba", tshirt: "Koszulka" },
      fields: { name: "Imię i nazwisko", email: "E-mail", address: "Adres pocztowy", country: "Narodowość / kraj", size: "Rozmiar koszulki", message: "Wiadomość (opcjonalnie)" },
      sizeHint: "Tylko dla koszulek", submit: "Wyślij dane", success: "Dziękujemy! Mamy Twoje dane i się odezwiemy.", error: "Coś poszło nie tak. Spróbuj ponownie.", videoNote: "Przykładowe wideo wkrótce.", privacy: "Twój adres służy wyłącznie do wysłania prezentu.",
    },
    giftFlow: {
      teaserOverline: "Małe podziękowanie",
      teaserHeading: "Każdy darczyńca otrzymuje ręcznie robiony prezent",
      teaserBody: "Kubek, torba lub koszulka, dopasowana do Twojego kraju. To nasz sposób na podziękowanie. Wpłać darowiznę i odbierz prezent w ostatnim kroku.",
      teaserCta: "Wesprzyj i odbierz prezent",
      step1Note: "Prezent wysyłamy po wpłacie. Zrób przelew poniżej i odbierz go w następnym kroku.",
      claimCta: "Zrobiłem przelew, odbierz prezent",
      skip: "Rezygnuję z prezentu",
      heading: "Odbierz swoje podziękowanie",
      intro: "Podaj tytuł przelewu, którego użyłeś, abyśmy mogli dopasować Twoją wpłatę. Prezent wysyłamy po potwierdzeniu przelewu.",
      back: "Wróć do danych przelewu",
      refLabel: "Tytuł użyty w przelewie",
      amountLabel: "Wpłacona kwota (opcjonalnie)",
      sizeLabel: "Wybierz rozmiar",
    },
    marquee: ["La Guaira", "Caracas", "Pomoc humanitarna", "Pomoc wolontariuszy"],
    galleryImg: GALLERY_IMG,
  },

  pt: {
    nav: { story: "A História", gallery: "Galeria", donate: "Doar" },
    hero: {
      overline: "Ajuda de emergência pelo terremoto · Venezuela",
      lines: ["Ajuda de emergência", "pelo terremoto", "Venezuela."],
      body: "Em 24 de junho de 2026, dois terremotos devastadores de magnitude 7,2 e 7,5 atingiram a Venezuela, afetando gravemente La Guaira, Caracas e as comunidades vizinhas. Milhares de pessoas perderam a vida, e muitas outras estão feridas, deslocadas ou sem lares, alimentos, água potável e suprimentos médicos.",
      donateNow: "Doar no GoFundMe", readStory: "Ler a história completa", caption: "Uma mensagem do Pastor Ángel Aner González", captionLoc: "Venezuela",
    },
    panel: {
      support: "Apoie a ajuda", choose: "Escolha um valor para contribuir.", customBtn: "Contribuir outro valor",
      raisedLine: (goal) => `arrecadados de uma meta de ${goal}`, donationsLabel: (n) => `${n} doações`,
      info: "As contribuições vão diretamente para comida, água potável e suprimentos para a comunidade na Venezuela. As doações são feitas por transferência bancária. Os detalhes aparecem na próxima etapa.",
      note: "As doações são feitas por transferência bancária para David e Reina na Espanha, que as enviam à família na Venezuela. Um comprovante (justificante) está disponível mediante solicitação.",
      manualUpdate: "Como as doações são feitas por transferência bancária manual, o valor arrecadado é atualizado aqui manualmente, volte a cada poucos dias para ver o total mais recente.",
    },
    scale: {
      overline: "A dimensão, segundo os relatórios",
      items: [{ value: "4.734", label: "vidas perdidas" }, { value: "16.740", label: "feridos" }, { value: "17.907", label: "casas perdidas" }],
      footnote: "Dados do Relatório de Situação nº 21 (14 de julho de 2026): 6.462 pessoas resgatadas e mais de 1.275 réplicas registradas. Números oficiais, sujeitos a mudança.",
    },
    trust: {
      overline: "Confiança e transparência", heading: "Como sua doação chega às pessoas",
      flow: "As doações vão para David e Reina, meus contatos diretos na Espanha, que as enviam à família na Venezuela. Junto com a igreja Iglesia Cristiana Ríos de Agua Viva (Pastor Ángel Aner González), a família compra e distribui a ajuda. Quem contribui pode receber um comprovante (justificante).",
      points: [
        { title: "100% para a ajuda", note: "Cada doação é gasta em comida, água e suprimentos. Nada é retido." },
        { title: "Comprovante", note: "Peça um justificante e enviaremos o comprovante da sua transferência." },
        { title: "Recibos e fotos", note: "Guardamos recibos e fotos das compras, disponíveis a pedido." },
        { title: "Vídeos", note: "Estamos adicionando vídeos curtos das pessoas envolvidas, para você ver aonde vai a ajuda." },
      ],
      contactLead: "Dúvidas? Fale com uma pessoa real:",
    },
    videos: { overline: "Da Venezuela", heading: "Veja você mesmo", intro: "Vídeos curtos que David e Reina compartilharam da família e da igreja em ação: comprando e distribuindo comida, água e suprimentos." },
    gallery: {
      overline: "No terreno", heading: "Fotografias do campo.", intro: "Fotografias sem edição dos nossos voluntários preparando e distribuindo comida e água.",
      captions: [BAGS_QUOTE, "Suprimentos reunidos para a comunidade", "Carregando água e suprimentos", "Comida e itens essenciais para as famílias", "Refeições e água, prontas para entrega", "Preparando refeições, uma a uma"],
    },
    donors: {
      grateful: "Com gratidão", getInvolved: "Participe", thanksHeading: "Obrigada a quem doou.", firstHeading: "Seja o primeiro a ajudar.",
      thanksBody: "Cada contribuição vai para comida e água para as equipes de resgate e sobreviventes. Somos gratos a todos que ajudaram.",
      firstBody: "Ainda não há doações. Esta iniciativa está começando e sua contribuição seria a primeira. Cada doação vai para comida e água.",
      contribute: "Contribuir", emptyTitle: "Ainda sem doadores", emptyBody: "Assim que chegar a primeira doação, ela aparecerá aqui, com uma mensagem se houver.", anon: "Contribuição anônima.",
    },
    footer: {
      support: "Apoiar", heading: "Obrigada pela sua solidariedade.", contribute: "Contribuir", organizedBy: "Organizado por",
      org2: "Pastor Ángel Aner González · uma arrecadação pessoal da Maria.", bottomOrg: "Uma arrecadação pessoal de Maria-Katharina Richters · Venezuela",
      shareText: "Apoie a ajuda aos terremotos na Venezuela. Comida e água após os terremotos de 24 de junho de 2026.", copyToast: "Link copiado. Obrigada por compartilhar.",
    },
    bank: {
      badge: "Doar por transferência bancária", anyAmount: "Qualquer valor é bem-vindo", transfer: (a) => `Transferir $${a}`,
      intro: 'As doações são feitas por transferência bancária. Use os dados abaixo e coloque "Venezuela Relief" e seu nome como referência para podermos agradecer e enviar um comprovante.',
      labels: { holder: "Titular da conta", bank: "Banco", iban: "IBAN", bic: "BIC / SWIFT", reference: "Referência" },
      referenceValue: "Venezuela Relief + seu nome", note: "Esta conta pertence a Reina Yohana Isaza Montoya (esposa de David), que envia os fundos à família na Venezuela.",
      paypal: "Ou doe com PayPal", copyToast: (label) => `${label} copiado`, contactHelp: "Prefere doar de outra forma? Fale conosco.",
    },
    gift: {
      overline: "Um pequeno agradecimento", heading: "Envie seu endereço para um presente de agradecimento",
      intro: "Como agradecimento pela sua doação, adoraríamos enviar um presente personalizado: uma caneca, uma bolsa ou uma camiseta. Diga-nos para onde enviar e sua nacionalidade (o design é personalizado). Veja o exemplo abaixo.",
      giftLabel: "Escolha um presente", gifts: { mug: "Caneca", bag: "Bolsa", tshirt: "Camiseta" },
      fields: { name: "Nome completo", email: "E-mail", address: "Endereço postal", country: "Nacionalidade / país", size: "Tamanho da camiseta", message: "Mensagem (opcional)" },
      sizeHint: "Apenas para camisetas", submit: "Enviar meus dados", success: "Obrigada! Temos seus dados e entraremos em contato.", error: "Algo deu errado. Tente novamente.", videoNote: "Vídeo de exemplo em breve.", privacy: "Seu endereço é usado apenas para enviar seu presente.",
    },
    giftFlow: {
      teaserOverline: "Um pequeno agradecimento",
      teaserHeading: "Cada doador recebe um presente artesanal de agradecimento",
      teaserBody: "Uma caneca, uma bolsa ou uma camiseta, personalizada para o seu país. É a nossa forma de dizer obrigada. Faça a sua doação e reivindique o presente na última etapa.",
      teaserCta: "Doe e receba o presente",
      step1Note: "O presente é enviado após a doação. Faça a transferência abaixo e reivindique-o na próxima etapa.",
      claimCta: "Já fiz a transferência, receber o presente",
      skip: "Dispenso o presente",
      heading: "Reivindique o seu presente de agradecimento",
      intro: "Informe a referência que você usou para identificarmos a sua doação. O presente é enviado após confirmarmos a transferência.",
      back: "Voltar aos dados da transferência",
      refLabel: "Referência que você usou na transferência",
      amountLabel: "Valor que você doou (opcional)",
      sizeLabel: "Escolha o seu tamanho",
    },
    marquee: ["La Guaira", "Caracas", "Ajuda humanitária", "Ajuda voluntária"],
    galleryImg: GALLERY_IMG,
  },

  fr: {
    nav: { story: "L'Histoire", gallery: "Galerie", donate: "Faire un don" },
    hero: {
      overline: "Aide d'urgence après le séisme · Venezuela",
      lines: ["Aide d'urgence", "après le séisme", "Venezuela."],
      body: "Le 24 juin 2026, deux séismes dévastateurs de magnitude 7,2 et 7,5 ont frappé le Venezuela, touchant gravement La Guaira, Caracas et les communautés voisines. Des milliers de personnes ont perdu la vie, et beaucoup d'autres sont blessées, déplacées ou privées de foyer, de nourriture, d'eau potable et de fournitures médicales.",
      donateNow: "Faire un don sur GoFundMe", readStory: "Lire l'histoire complète", caption: "Un message du Pasteur Ángel Aner González", captionLoc: "Venezuela",
    },
    panel: {
      support: "Soutenez l'aide", choose: "Choisissez un montant.", customBtn: "Donner un autre montant",
      raisedLine: (goal) => `collectés sur un objectif de ${goal}`, donationsLabel: (n) => `${n} dons`,
      info: "Les contributions vont directement à la nourriture, l'eau potable et les fournitures pour la communauté au Venezuela. Les dons se font par virement bancaire. Les détails apparaissent à l'étape suivante.",
      note: "Les dons sont versés par virement à David et Reina en Espagne, qui les envoient à leur famille au Venezuela. Un justificatif (justificante) est disponible sur demande.",
      manualUpdate: "Comme les dons se font par virement bancaire manuel, le montant collecté est mis à jour ici à la main, revenez tous les quelques jours pour voir le dernier total.",
    },
    scale: {
      overline: "L'ampleur, selon les rapports",
      items: [{ value: "4 734", label: "vies perdues" }, { value: "16 740", label: "blessés" }, { value: "17 907", label: "foyers détruits" }],
      footnote: "Chiffres du Rapport de Situation n° 21 (14 juillet 2026) : 6 462 personnes secourues et plus de 1 275 répliques enregistrées. Chiffres officiels, susceptibles d'évoluer.",
    },
    trust: {
      overline: "Confiance et transparence", heading: "Comment votre don atteint les gens",
      flow: "Les dons vont à David et Reina, mes contacts directs en Espagne, qui les envoient à leur famille au Venezuela. Avec l'église Iglesia Cristiana Ríos de Agua Viva (Pasteur Ángel Aner González), leur famille achète et distribue l'aide. Chaque donateur peut recevoir un justificatif (justificante).",
      points: [
        { title: "100% pour l'aide", note: "Chaque don sert à la nourriture, l'eau et les fournitures. Rien n'est prélevé." },
        { title: "Justificatif de virement", note: "Demandez un justificante et nous vous enverrons la confirmation de virement." },
        { title: "Reçus et photos", note: "Nous conservons reçus et photos des achats, disponibles sur demande." },
        { title: "Vidéos", note: "Nous ajoutons de courtes vidéos des personnes impliquées, pour voir où va votre aide." },
      ],
      contactLead: "Des questions ? Contactez une personne réelle :",
    },
    videos: { overline: "Depuis le Venezuela", heading: "Voyez par vous-même", intro: "De courtes vidéos partagées par David et Reina montrant la famille et leur église à l'œuvre : achats et distribution de nourriture, d'eau et de fournitures." },
    gallery: {
      overline: "Sur le terrain", heading: "Photographies du terrain.", intro: "Photographies non retouchées de nos bénévoles préparant et distribuant nourriture et eau.",
      captions: [BAGS_QUOTE, "Fournitures rassemblées pour la communauté", "Chargement d'eau et de fournitures", "Nourriture et produits essentiels pour les familles", "Repas et eau, prêts à être livrés", "Préparation des repas, un par un"],
    },
    donors: {
      grateful: "Avec gratitude", getInvolved: "Participez", thanksHeading: "Merci à ceux qui ont donné.", firstHeading: "Soyez le premier à aider.",
      thanksBody: "Chaque contribution va à la nourriture et l'eau pour les équipes de secours et les survivants. Merci à tous ceux qui ont aidé.",
      firstBody: "Aucun don pour le moment. Cette initiative débute à peine, et votre contribution serait la première. Chaque don va à la nourriture et à l'eau.",
      contribute: "Contribuer", emptyTitle: "Aucun donateur pour l'instant", emptyBody: "Dès le premier don, il apparaîtra ici, avec un message s'il en est laissé un.", anon: "Don anonyme.",
    },
    footer: {
      support: "Soutenir", heading: "Merci pour votre solidarité.", contribute: "Contribuer", organizedBy: "Organisé par",
      org2: "Pasteur Ángel Aner González · une collecte personnelle de Maria.", bottomOrg: "Une collecte personnelle de Maria-Katharina Richters · Venezuela",
      shareText: "Soutenez l'aide aux séismes au Venezuela. Nourriture et eau après les séismes du 24 juin 2026.", copyToast: "Lien copié. Merci de partager.",
    },
    bank: {
      badge: "Faire un don par virement", anyAmount: "Tout montant est bienvenu", transfer: (a) => `Virer $${a}`,
      intro: 'Les dons se font par virement bancaire. Utilisez les coordonnées ci-dessous et indiquez "Venezuela Relief" et votre nom en référence pour que nous puissions vous remercier et envoyer un justificatif.',
      labels: { holder: "Titulaire du compte", bank: "Banque", iban: "IBAN", bic: "BIC / SWIFT", reference: "Référence" },
      referenceValue: "Venezuela Relief + votre nom", note: "Ce compte appartient à Reina Yohana Isaza Montoya (épouse de David), qui envoie les fonds à leur famille au Venezuela.",
      paypal: "Ou faire un don avec PayPal", copyToast: (label) => `${label} copié`, contactHelp: "Vous préférez donner autrement ? Contactez-nous.",
    },
    gift: {
      overline: "Un petit merci", heading: "Envoyez votre adresse pour un cadeau de remerciement",
      intro: "En remerciement de votre don, nous aimerions vous envoyer un cadeau personnalisé : un mug, un tote bag ou un t-shirt. Dites-nous où l'envoyer et votre nationalité (le design est personnalisé). Voir l'exemple ci-dessous.",
      giftLabel: "Choisissez un cadeau", gifts: { mug: "Mug", bag: "Tote bag", tshirt: "T-shirt" },
      fields: { name: "Nom complet", email: "E-mail", address: "Adresse postale", country: "Nationalité / pays", size: "Taille de t-shirt", message: "Message (facultatif)" },
      sizeHint: "Uniquement pour les t-shirts", submit: "Envoyer mes coordonnées", success: "Merci ! Nous avons vos coordonnées et vous recontacterons.", error: "Un problème est survenu. Réessayez.", videoNote: "Vidéo d'exemple bientôt disponible.", privacy: "Votre adresse sert uniquement à envoyer votre cadeau.",
    },
    giftFlow: {
      teaserOverline: "Un petit merci",
      teaserHeading: "Chaque donateur reçoit un cadeau de remerciement fait main",
      teaserBody: "Un mug, un tote bag ou un t-shirt, personnalisé à votre pays. C'est notre façon de dire merci. Faites un don, puis réclamez votre cadeau à la dernière étape.",
      teaserCta: "Faire un don et réclamer le cadeau",
      step1Note: "Votre cadeau est envoyé après votre don. Faites votre virement ci-dessous, puis réclamez-le à l'étape suivante.",
      claimCta: "J'ai fait mon virement, réclamer mon cadeau",
      skip: "Je renonce au cadeau",
      heading: "Réclamez votre cadeau de remerciement",
      intro: "Indiquez la référence que vous avez utilisée pour que nous puissions identifier votre don. Votre cadeau est envoyé une fois votre virement confirmé.",
      back: "Retour aux coordonnées bancaires",
      refLabel: "Référence utilisée pour le virement",
      amountLabel: "Montant de votre don (facultatif)",
      sizeLabel: "Choisissez votre taille",
    },
    marquee: ["La Guaira", "Caracas", "Aide humanitaire", "Aide bénévole"],
    galleryImg: GALLERY_IMG,
  },

  zh: {
    nav: { story: "故事", gallery: "图库", donate: "捐款" },
    hero: {
      overline: "地震紧急救援 · 委内瑞拉",
      lines: ["地震", "紧急救援", "委内瑞拉。"],
      body: "2026 年 6 月 24 日，两次分别为 7.2 级和 7.5 级的强烈地震袭击委内瑞拉，重创拉瓜伊拉、加拉加斯及周边社区。数千人不幸罹难，更多人受伤、流离失所，失去家园、食物、清洁饮用水和医疗物资。",
      donateNow: "在 GoFundMe 上捐款", readStory: "阅读完整故事", caption: "来自 Ángel Aner González 牧师的讯息", captionLoc: "委内瑞拉",
    },
    panel: {
      support: "支持救援", choose: "选择捐款金额。", customBtn: "捐赠其他金额",
      raisedLine: (goal) => `已筹集，目标 ${goal}`, donationsLabel: (n) => `${n} 笔捐款`,
      info: "善款将直接用于委内瑞拉社区的食物、饮用水和物资。捐款通过银行转账进行，详情见下一步。",
      note: "捐款通过银行转账给在西班牙的 David 和 Reina，再由他们转交委内瑞拉的家人。可应要求提供转账凭证（justificante）。",
      manualUpdate: "由于捐款通过人工银行转账完成，筹得金额在此手动更新, 请每隔几天回来查看最新总额。",
    },
    scale: {
      overline: "灾情规模（据报告）",
      items: [{ value: "4,734", label: "遇难" }, { value: "16,740", label: "受伤" }, { value: "17,907", label: "房屋损毁" }],
      footnote: "数据来自第21号情况报告（2026年7月14日）：已救出6,462人，记录到超过1,275次余震。为官方数字，可能随救援进展而变化。",
    },
    trust: {
      overline: "信任与透明", heading: "您的捐款如何送达当地民众",
      flow: "捐款交给我在西班牙的直接联系人 David 和 Reina，再由他们转交委内瑞拉的家人。他们的家人与 Iglesia Cristiana Ríos de Agua Viva 教会（Ángel Aner González 牧师）一起采购并发放物资。每位捐款者都可获得转账凭证（justificante）。",
      points: [
        { title: "100% 用于援助", note: "每一笔捐款都用于食物、饮水和物资，分文不留。" },
        { title: "转账凭证", note: "索取 justificante，我们会提供您捐款的转账确认。" },
        { title: "收据与照片", note: "我们保留采购收据和照片，可应任何捐款者要求提供。" },
        { title: "视频更新", note: "我们正在添加相关人员的短视频，让您看到善款的去向。" },
      ],
      contactLead: "有疑问？联系真实的人：",
    },
    videos: { overline: "来自委内瑞拉", heading: "亲眼见证", intro: "David 和 Reina 分享的短视频，记录家人和教会的工作：采购并分发食物、饮水和物资。" },
    gallery: {
      overline: "来自现场", heading: "现场照片。", intro: "我们志愿者准备和分发食物与饮水的未经修饰的照片。",
      captions: [BAGS_QUOTE, "为社区筹集的物资", "装载饮水和物资", "为家庭准备的食物和必需品", "备好待发的餐食和饮水", "一份份准备餐食"],
    },
    donors: {
      grateful: "心怀感激", getInvolved: "参与进来", thanksHeading: "感谢所有捐款的人。", firstHeading: "成为第一个伸出援手的人。",
      thanksBody: "每一笔捐款都用于为救援队和幸存者提供食物和清洁饮水。感谢每一位帮助过的人。",
      firstBody: "目前还没有捐款。这项行动刚刚开始，您的捐款将是第一笔。每一份善款都用于当地的食物和饮水。",
      contribute: "捐款", emptyTitle: "暂无捐款者", emptyBody: "一旦收到第一笔捐款，就会显示在这里，如附有留言也会一并显示。", anon: "匿名捐款。",
    },
    footer: {
      support: "支持", heading: "感谢您的声援。", contribute: "捐款", organizedBy: "发起人",
      org2: "Ángel Aner González 牧师 · Maria 发起的个人筹款。", bottomOrg: "Maria-Katharina Richters 发起的个人筹款 · 委内瑞拉",
      shareText: "支持委内瑞拉地震救援。为2026年6月24日地震后的救援队和幸存者提供食物和清洁饮水。", copyToast: "链接已复制，感谢分享。",
    },
    bank: {
      badge: "通过银行转账捐款", anyAmount: "任何金额都欢迎", transfer: (a) => `转账 $${a}`,
      intro: '捐款通过银行转账进行。请使用下方信息，并在附言中填写 "Venezuela Relief" 和您的姓名，以便我们致谢并寄送凭证。',
      labels: { holder: "账户持有人", bank: "银行", iban: "IBAN", bic: "BIC / SWIFT", reference: "附言" },
      referenceValue: "Venezuela Relief + 您的姓名", note: "该账户属于 Reina Yohana Isaza Montoya（David 的妻子），她会将款项转交委内瑞拉的家人。",
      paypal: "或使用 PayPal 捐款", copyToast: (label) => `已复制${label}`, contactHelp: "想用其他方式捐款？请联系我们。",
    },
    gift: {
      overline: "小小的谢意", heading: "留下地址，领取感谢礼物",
      intro: "为感谢您的捐款，我们很乐意寄送一份定制礼物：马克杯、帆布袋或T恤。请告诉我们寄送地址和您的国籍（设计会据此定制）。请看下方示例。",
      giftLabel: "选择礼物", gifts: { mug: "马克杯", bag: "帆布袋", tshirt: "T恤" },
      fields: { name: "全名", email: "电子邮箱", address: "邮寄地址", country: "国籍 / 国家", size: "T恤尺码", message: "留言（可选）" },
      sizeHint: "仅T恤需要", submit: "提交我的信息", success: "谢谢！我们已收到您的信息，会与您联系。", error: "出了点问题，请重试。", videoNote: "示例视频即将上线。", privacy: "您的地址仅用于寄送感谢礼物。",
    },
    giftFlow: {
      teaserOverline: "小小的感谢",
      teaserHeading: "每位捐款者都会收到手工感谢礼物",
      teaserBody: "马克杯、帆布袋或T恤，根据您的国家定制。这是我们表达感谢的方式。捐款后即可在最后一步领取您的礼物。",
      teaserCta: "捐款并领取礼物",
      step1Note: "礼物将在您捐款后寄出。请在下方完成转账，然后在下一步领取。",
      claimCta: "我已完成转账, 领取礼物",
      skip: "我不需要礼物",
      heading: "领取您的感谢礼物",
      intro: "请填写您转账时使用的备注，以便我们核对您的捐款。确认到账后我们将寄出礼物。",
      back: "返回转账信息",
      refLabel: "您转账时使用的备注",
      amountLabel: "您的捐款金额（选填）",
      sizeLabel: "选择尺码",
    },
    marquee: ["拉瓜伊拉", "加拉加斯", "人道援助", "志愿援助"],
    galleryImg: GALLERY_IMG,
  },

  nl: {
    nav: { story: "Het Verhaal", gallery: "Galerij", donate: "Doneren" },
    hero: {
      overline: "Noodhulp na aardbeving · Venezuela",
      lines: ["Noodhulp", "na aardbeving", "Venezuela."],
      body: "Op 24 juni 2026 troffen twee verwoestende aardbevingen met een kracht van 7,2 en 7,5 Venezuela en teisterden La Guaira, Caracas en omliggende gemeenschappen zwaar. Duizenden mensen hebben het leven verloren, en velen meer zijn gewond, ontheemd of zonder huis, voedsel, schoon drinkwater en medische voorzieningen.",
      donateNow: "Doneren op GoFundMe", readStory: "Lees het volledige verhaal", caption: "Een bericht van pastor Ángel Aner González", captionLoc: "Venezuela",
    },
    panel: {
      support: "Steun de hulp", choose: "Kies een bedrag om bij te dragen.", customBtn: "Ander bedrag doneren",
      raisedLine: (goal) => `opgehaald van ${goal} doel`, donationsLabel: (n) => `${n} donaties`,
      info: "Bijdragen gaan rechtstreeks naar voedsel, schoon water en benodigdheden voor de gemeenschap in Venezuela. Donaties gaan via bankoverschrijving. De gegevens verschijnen in de volgende stap.",
      note: "Donaties gaan via bankoverschrijving naar David en Reina in Spanje, die ze doorsturen naar hun familie in Venezuela. Een bewijs (justificante) is op verzoek beschikbaar.",
      manualUpdate: "Omdat donaties via een handmatige bankoverboeking worden gedaan, wordt het opgehaalde bedrag hier met de hand bijgewerkt, kom elke paar dagen terug voor het laatste totaal.",
    },
    scale: {
      overline: "De omvang, volgens rapporten",
      items: [{ value: "4.734", label: "doden" }, { value: "16.740", label: "gewonden" }, { value: "17.907", label: "verwoeste huizen" }],
      footnote: "Cijfers uit Situatierapport nr. 21 (14 juli 2026): 6.462 geredde personen en meer dan 1.275 geregistreerde naschokken. Officiële cijfers, kunnen veranderen.",
    },
    trust: {
      overline: "Vertrouwen & transparantie", heading: "Hoe jouw donatie de mensen bereikt",
      flow: "Donaties gaan naar David en Reina, mijn directe contacten hier in Spanje, die ze doorsturen naar hun familie in Venezuela. Samen met de kerk Iglesia Cristiana Ríos de Agua Viva (Pastor Ángel Aner González) koopt en verdeelt hun familie de hulp. Iedereen die bijdraagt kan een bewijs (justificante) ontvangen.",
      points: [
        { title: "100% naar hulp", note: "Elke donatie gaat naar voedsel, water en benodigdheden. Er wordt niets ingehouden." },
        { title: "Overschrijvingsbewijs", note: "Vraag om een justificante en we sturen je de overschrijvingsbevestiging." },
        { title: "Bonnen & foto's", note: "We bewaren bonnen en foto's van aankopen, op verzoek beschikbaar." },
        { title: "Video-updates", note: "We voegen korte video's toe van de betrokkenen, zodat je ziet waar je hulp heen gaat." },
      ],
      contactLead: "Vragen? Bereik een echt persoon:",
    },
    videos: { overline: "Uit Venezuela", heading: "Zie het zelf", intro: "Korte video's die David en Reina deelden van de familie en hun kerk aan het werk: het kopen en uitdelen van voedsel, water en benodigdheden." },
    gallery: {
      overline: "Vanuit het veld", heading: "Foto's uit het veld.", intro: "Onbewerkte foto's van onze vrijwilligers die voedsel en water bereiden en uitdelen.",
      captions: [BAGS_QUOTE, "Benodigdheden verzameld voor de gemeenschap", "Water en benodigdheden worden geladen", "Voedsel en basisbenodigdheden voor de gezinnen", "Maaltijden en water, klaar om te bezorgen", "Maaltijden bereiden, één voor één"],
    },
    donors: {
      grateful: "Met dankbaarheid", getInvolved: "Doe mee", thanksHeading: "Dank aan iedereen die doneerde.", firstHeading: "Wees de eerste die helpt.",
      thanksBody: "Elke bijdrage gaat naar voedsel en schoon water voor de reddingsteams en overlevenden. We zijn dankbaar voor iedereen die geholpen heeft.",
      firstBody: "Nog geen donaties. Deze actie begint net, en jouw bijdrage zou de eerste zijn. Elke gift gaat naar voedsel en schoon water ter plaatse.",
      contribute: "Doneren", emptyTitle: "Nog geen donateurs", emptyBody: "Zodra de eerste donatie binnenkomt, verschijnt die hier, met een bericht als dat is achtergelaten.", anon: "Anoniem gedoneerd.",
    },
    footer: {
      support: "Steun", heading: "Bedankt voor je solidariteit.", contribute: "Doneren", organizedBy: "Georganiseerd door",
      org2: "Pastor Ángel Aner González · een persoonlijke inzamelingsactie van Maria.", bottomOrg: "Een persoonlijke inzamelingsactie van Maria-Katharina Richters · Venezuela",
      shareText: "Steun de aardbevingshulp in Venezuela. Voedsel en schoon water na de aardbevingen van 24 juni 2026.", copyToast: "Link gekopieerd. Bedankt voor het delen.",
    },
    bank: {
      badge: "Doneren via bankoverschrijving", anyAmount: "Elk bedrag is welkom", transfer: (a) => `$${a} overmaken`,
      intro: 'Donaties gaan via bankoverschrijving. Gebruik de onderstaande gegevens en zet "Venezuela Relief" en je naam als omschrijving, zodat we je kunnen bedanken en een bewijs sturen.',
      labels: { holder: "Rekeninghouder", bank: "Bank", iban: "IBAN", bic: "BIC / SWIFT", reference: "Omschrijving" },
      referenceValue: "Venezuela Relief + je naam", note: "Deze rekening is van Reina Yohana Isaza Montoya (Davids vrouw), die de middelen doorstuurt naar hun familie in Venezuela.",
      paypal: "Of doneer met PayPal", copyToast: (label) => `${label} gekopieerd`, contactHelp: "Liever op een andere manier doneren? Neem contact met ons op.",
    },
    gift: {
      overline: "Een klein bedankje", heading: "Stuur je adres voor een bedankcadeau",
      intro: "Als dank voor je donatie sturen we je graag een gepersonaliseerd cadeau: een mok, een tas of een T-shirt. Vertel ons waar we het heen sturen en je nationaliteit (het ontwerp wordt daarop afgestemd). Bekijk het voorbeeld hieronder.",
      giftLabel: "Kies een cadeau", gifts: { mug: "Mok", bag: "Tas", tshirt: "T-shirt" },
      fields: { name: "Volledige naam", email: "E-mail", address: "Postadres", country: "Nationaliteit / land", size: "T-shirtmaat", message: "Bericht (optioneel)" },
      sizeHint: "Alleen voor T-shirts", submit: "Mijn gegevens versturen", success: "Bedankt! We hebben je gegevens en nemen contact op.", error: "Er ging iets mis. Probeer het opnieuw.", videoNote: "Voorbeeldvideo binnenkort.", privacy: "Je adres wordt alleen gebruikt om je bedankcadeau te versturen.",
    },
    giftFlow: {
      teaserOverline: "Een klein bedankje",
      teaserHeading: "Elke donateur ontvangt een handgemaakt bedankcadeau",
      teaserBody: "Een mok, tote bag of T-shirt, afgestemd op jouw land. Het is onze manier om dankjewel te zeggen. Doneer en claim je cadeau in de laatste stap.",
      teaserCta: "Doneer & claim je cadeau",
      step1Note: "Je cadeau wordt verstuurd nadat je hebt gedoneerd. Maak hieronder je overboeking en claim het in de volgende stap.",
      claimCta: "Ik heb overgemaakt, claim mijn cadeau",
      skip: "Ik hoef geen cadeau",
      heading: "Claim je bedankcadeau",
      intro: "Voer de omschrijving in die je hebt gebruikt zodat we je donatie kunnen matchen. Je cadeau wordt verstuurd zodra we je overboeking hebben bevestigd.",
      back: "Terug naar de overboekingsgegevens",
      refLabel: "Omschrijving die je bij de overboeking gebruikte",
      amountLabel: "Bedrag dat je hebt gedoneerd (optioneel)",
      sizeLabel: "Kies je maat",
    },
    marquee: ["La Guaira", "Caracas", "Humanitaire hulp", "Vrijwilligershulp"],
    galleryImg: GALLERY_IMG,
  },
};
